"use client";
import Link from "next/link";
import { Logo } from "./logo";
import React from "react";
import { ModeToggle } from "./mode-toggle";

export const HeroHeader = () => {
  return (
    <header>
      <nav className="bg-background/50 fixed z-20 w-full border-b backdrop-blur-3xl">
        <div className="mx-auto max-w-6xl px-2 sm:px-4 md:px-6 transition-all duration-300">
          <div className="relative flex items-center gap-6 py-3 lg:gap-0 lg:py-4">
            {/* Logo and theme toggle for mobile */}
            <div className="flex w-full items-center justify-between lg:w-auto lg:justify-start">
              <Link
                href="/"
                aria-label="home"
                className="flex items-center space-x-2"
              >
                <Logo />
              </Link>
              {/* Show theme toggle next to logo on mobile */}
              <div className="block lg:hidden">
                <ModeToggle />
              </div>
            </div>
            {/* On large screens, push theme toggle to far right */}
            <div className="hidden lg:flex flex-1 items-center justify-end">
              <ModeToggle />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};
